import { DigitalWalletKeysDto } from "@admin_api/models/digital-wallet-keys-dto";

export class GooglePayKeysState {
    error = null;
    record: DigitalWalletKeysDto = null;
    loading = false;
}
